import { render } from "./WeekPicksAnalysis.vue?vue&type=template&id=6f37ad3e&scoped=true"
import script from "./WeekPicksAnalysis.vue?vue&type=script&lang=ts"
export * from "./WeekPicksAnalysis.vue?vue&type=script&lang=ts"

import "./WeekPicksAnalysis.vue?vue&type=style&index=0&id=6f37ad3e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f37ad3e"

export default script